import React, { Component } from "react";
import SelectTable from "../Tables/SelectTable";
import { ButtonWithIcon } from "../ButtonWithIcon";
import { DropDownButtonWithRouter } from "../DropDownButton";
import { filmCreditsFlexHelper } from "../../utilities/utilities";
import {
	defaultOrderBy,
	foldersOnTopOrderedBy,
} from "../../utilities/tableSortUtils";
import { trashBinRedButtonText } from "./trashBinUtils.js";
import { IconArrowUp } from "@tabler/icons-react";
import { connect } from "react-redux";
import {
	generatePermanentDeleteManifestForMultiselect,
	restoreMultiSelectTrashPage,
	setAllCheckboxes,
} from "../../actions/multiselectActions";
import { updateUserSetting } from "../../actions/userSettingsActions";

import {
	selectTableRootMap,
	selectTableTypeMap,
} from "../../reducers/multiselectReducer";
import { generatePermanentDeleteManifestFromTrashList } from "../../actions/documentActions";
import { IconFileShredder, IconInfoCircle } from "@tabler/icons-react";
import { LexWorkplaceGavelIcon } from "../LexWorkplaceIcons.js";

const getRestoreMenuItem = (props) => {
	const { selectedItems, restoreMultiSelectTrashPage, trashPageContext } =
		props;
	const count =
		Object.keys(selectedItems.Object).length +
		Object.keys(selectedItems.Folder).length;

	const text = "Restore from Trash Bin" + (count ? " (" + count + ")" : "");
	const onSelect = () =>
		restoreMultiSelectTrashPage({
			selectedItems,
			trashPageContext: trashPageContext.replace("/", ""),
		});
	const disabled = selectedItems === null || count === 0;

	return { text, onSelect, disabled };
};

function getTooltipText(trashView) {
	if (trashView === "Documents") {
		return "Documents that are inside a Folder or Matter in the Trash Bin are not listed here.";
	}
	if (trashView === "Email") {
		return "Emails that are inside a Folder or Matter in the Trash Bin are not listed here.";
	}
	if (trashView === "Notes") {
		return "Notes that are inside a Folder or Matter in the Trash Bin are not listed here.";
	}
	if (trashView === "Matters") {
		return "All Matters in the Trash Bin are listed here.";
	}
	if (trashView === "Clients") {
		return "All Clients in the Trash Bin are listed here.";
	}
	return "";
}

class TrashBinList extends Component {
	constructor(props, context) {
		super(props, context);
		this.state = {
			itemsMatchingFilter: [],
		};

		this.headerBoxClicked = this.headerBoxClicked.bind(this);
		this.toggleFoldersOnTop = this.toggleFoldersOnTop.bind(this);
		this.setItemsMatchingFilter = this.setItemsMatchingFilter.bind(this);
		this.getActionMenuItems = this.getActionMenuItems.bind(this);
	}

	setItemsMatchingFilter(itemsMatchingFilter) {
		if (
			itemsMatchingFilter.length != this.state.itemsMatchingFilter.length
		) {
			this.setState({ itemsMatchingFilter });
		}
	}
	headerBoxClicked() {
		var config = { Object: {}, Folder: {} /*, header: newChecked*/ };
		if (this.state.itemsMatchingFilter.length) {
			this.state.itemsMatchingFilter.forEach((item) => {
				let originalItem = item._original ? item._original : item;
				config[selectTableTypeMap[originalItem.type]][originalItem.id] =
					{
						...originalItem,
					};
			});
		} else {
			this.props.trashList.forEach((item) => {
				config[selectTableTypeMap[item.type]][item.id] = { ...item };
			});
		}

		this.props.setAllCheckboxes(
			selectTableRootMap[`trash/${this.props.trashPageContext}`],
			config
		);
	}

	toggleFoldersOnTop() {
		this.props.updateUserSetting("foldersOnTop", !this.props.foldersOnTop);
	}

	getActionMenuItems(openCsvExport) {
		let actionMenuItems = [];
		if (
			["docs/", "email/", "notes/"].includes(this.props.trashPageContext)
		) {
			actionMenuItems.push({
				type: "label",
				text: filmCreditsFlexHelper(
					<>
						{`Folders toggle moved to Show `}
						<IconArrowUp
							size={14}
							style={{ verticalAlign: "sub" }}
						/>
					</>
				),
			});
			actionMenuItems.push({ divider: true });
		}

		actionMenuItems.push(getRestoreMenuItem(this.props));
		actionMenuItems.push({ divider: true });
		actionMenuItems.push({
			text: "Export Data as CSV",
			onSelect: openCsvExport,
		});

		return actionMenuItems;
	}

	render() {
		return (
			<div className="fullHeightFlex">
				<SelectTable
					className="fullWidth"
					foldersOnTop={this.props.foldersOnTop}
					onToggleFoldersOnTop={
						["docs/", "email/", "notes/"].includes(
							this.props.trashPageContext
						)
							? this.toggleFoldersOnTop
							: undefined
					}
					actionButtons={({ openCsvExport }) => (
						<div style={{ display: "flex", gap: 8 }}>
							<ButtonWithIcon
								className="redButton"
								handler={() => {
									if (this.props.selectItemsCount > 0) {
										// if we have selected items, pass those to generatePermanentDeleteManifestForMultiselect
										this.props.generatePermanentDeleteManifestForMultiselect(
											{
												selectedItems:
													this.props.selectedItems,
												trashPageContext:
													this.props.trashPageContext.replace(
														"/",
														""
													),
											}
										);
									} else {
										// pass the entire trashList to generatePermanentDeleteManifestFromTrashList
										// it will handle transforming the trashList into the correct format
										this.props.generatePermanentDeleteManifestFromTrashList(
											{
												trashList: this.props.trashList,
												trashPageContext:
													this.props.trashPageContext,
											}
										);
									}
								}}
								buttonText={this.props.bigRedButtonText}
								disabled={this.props.trashList.length === 0}
								disabledHoverText={
									this.props.trashList.length === 0
										? `There are no ${this.props.breadcrumbRootName} in the Trash Bin to delete`
										: ""
								}
								iconComponent={
									<IconFileShredder
										size={20}
										style={{ verticalAlign: "middle" }}
									/>
								}
							/>
							<DropDownButtonWithRouter
								title="Actions"
								iconComponent={<LexWorkplaceGavelIcon />}
								pullRight
								menuItems={this.getActionMenuItems(
									openCsvExport
								)}
							/>
						</div>
					)}
					leftSideFilterSpace={
						<div
							style={{
								display: "flex",
								marginTop: 10,
								marginRight: 12,
								marginBottom: 10,
								marginLeft: 12,
								alignItems: "center",
								maxWidth: "40rem",
							}}
						>
							<div>
								{this.props.breadcrumbRootName} in the Trash Bin
							</div>
							<span
								title={getTooltipText(
									this.props.breadcrumbRootName
								)}
							>
								<IconInfoCircle
									size={16}
									style={{
										marginLeft: 8,
										verticalAlign: "text-top",
									}}
								/>
							</span>
						</div>
					}
					csvExport={{
						fileName:
							this.props.tabUrlMap[this.props.trashPageContext]
								.csvFileName,
						extraColumns: ["docs/", "email/", "notes/"].includes(
							this.props.trashPageContext
						)
							? [
									{
										Header: "Is Folder",
										accessor: (row) =>
											row.type === "Folder" ? "Yes" : "",
									},
								]
							: [],
					}}
					data={this.props.loading ? [] : this.props.trashList}
					autoResize
					root={`trash/${this.props.trashPageContext}`}
					columns={
						this.props.tabUrlMap[this.props.trashPageContext]
							.columns
					}
					headerBoxClicked={this.headerBoxClicked}
					loading={this.props.loading}
					loadingMessage={this.props.loadingMessage}
					noResultsText={
						this.props.tabUrlMap[this.props.trashPageContext]
							.noResultsText
					}
					filterable
					defaultSorted={[{ id: "filename" }]}
					onSortedChange={(newSorted) => {
						newSorted.filter((sort) => sort.id === "filename");
					}}
					orderByMethod={
						this.props.foldersOnTop
							? foldersOnTopOrderedBy
							: defaultOrderBy
					}
					tableUniqueID={
						this.props.tabUrlMap[this.props.trashPageContext]
							.tableUniqueId
					}
					onFilteredChange={(filteredColumns) => {
						if (!filteredColumns || !filteredColumns.length) {
							this.setItemsMatchingFilter([]);
						}
					}}
					filteringCompleteCallback={(
						filteredData,
						filterId,
						activeFilters
					) => {
						if (activeFilters.length === 0) {
							this.setItemsMatchingFilter([]);
						} else {
							const lastActiveFilterId =
								activeFilters.slice(-1)[0].id;
							if (activeFilters.length === 1) {
								this.setItemsMatchingFilter(
									filteredData,
									lastActiveFilterId
								);
							} else if (lastActiveFilterId === filterId) {
								this.setItemsMatchingFilter(
									filteredData,
									lastActiveFilterId
								);
							} else {
								console.log("not last filter");
							}
						}
					}}
				/>
			</div>
		);
	}
}

const mapStateToProps = (state, props) => {
	const selectedItems =
		state.multiselect[
			props.tabUrlMap[props.trashPageContext].selectionListName
		];
	const selectItemsCount = selectedItems
		? Object.keys(selectedItems.Object).length +
			Object.keys(selectedItems.Folder).length
		: 0;
	const bigRedButtonText = trashBinRedButtonText({
		selectedItems,
		trashPageContextWithTrailingSlash: props.trashPageContext,
	});
	return {
		selectedItems,
		selectItemsCount,
		bigRedButtonText,
	};
};

export default connect(mapStateToProps, {
	updateUserSetting,
	setAllCheckboxes,
	generatePermanentDeleteManifestForMultiselect,
	generatePermanentDeleteManifestFromTrashList,
	restoreMultiSelectTrashPage,
})(TrashBinList);
